import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import BarChart from '../../../components/Charts/BarChart';
import ChartWrapper from '../../../components/Charts/ChartWrapper';
import PerformanceInsightTooltip from '../../../components/Charts/CustomToolTips/PerformanceInsightTooltip';
import useChartFilter from '../../../hooks/dashboard/companyInsight/useChartFilter';
import { PerformanceTimeline } from '../../../hooks/dashboard/companyInsight/useCompanyInsightChartData';
import ChartFilter from '../CompanyInsight/ChartFilter';

interface CompanyPerformanceInsightsProps {
  performanceTierData: PerformanceTimeline[];
}

const CompanyPerformanceInsights: React.FC<CompanyPerformanceInsightsProps> = ({
  performanceTierData,
}) => {
  const { chartFilter, chartData } = useChartFilter();

  const [dataUrl, setDataUrl] = useState<string>(`ba/v1/configs/current`);

  useEffect(() => {
    if (!dataUrl) return;

    chartFilter(dataUrl);
    // eslint-disable-next-line
  }, [dataUrl]);

  return (
    <Container>
      <ChartWrapper
        label=''
        maxWidth='100%'
        tooltipData={`Company's tier performance over a period of months in a year.`}
      >
        <HeaderArea>
          <Header>Company Performance Insights</Header>

          <ControlArea>
            <ChartFilter setDataUrl={setDataUrl} dataUrl={dataUrl} />
          </ControlArea>
        </HeaderArea>
        <BarChart
          xAxisDataKey='monthName'
          data={performanceTierData}
          isAnimationActive={true}
          dataKeys={['averageTierScore']}
          fills={['#5B91F5']}
          showLegend={false}
          yLabel='Average Tier Score per month'
          // barwidth={30}
          externalTooltip={{
            content: (
              <PerformanceInsightTooltip
                tierThresholds={chartData?.tierThreshold}
              />
            ),
          }}
        />
      </ChartWrapper>
    </Container>
  );
};

export default CompanyPerformanceInsights;

const Container = styled.div`
  width: 100%;
  grid-column: span 3;
`;

const ControlArea = styled.div`
  display: flex;
  /* border: 1px solid red; */
`;

const HeaderArea = styled.div`
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;

  /* border: 1px solid red; */
  margin-bottom: 18px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
`;
